import React from "react";
import GallerySliderComp from "./gallerySliderComp";

const ProjectContributionView = (props) => {
  // TODO: have an eye on imgHeight = 700px
  const handleContributionClick = (title) => {
    // Prevent default anchor behavior
    const cardId = title.toLowerCase().replace(/\s+/g, '-');
    const element = document.getElementById(cardId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="sm:min-w-[700px] min-w-[360px] animate-fade-in">
      <div className="flex xl:flex-row flex-col justify-center items-center h-[700px] sm:h-[1100px] xl:h-[600px] max-w-screen-2xl mx-auto bg-gradient-to-br from-primary-50 to-primary-100 rounded-lg shadow-lg">
        <div className="sm:block hidden animate-slide-in-left">
          <div className="sm:h-[500px] h-[300px] w-[360px] sm:w-[520px] xl:w-[750px] rounded-lg overflow-hidden shadow-xl">
            <div className="flex justify-center items-center h-full">
              <GallerySliderComp
                imgSlides={props.projectContribution.highlights}
                imgHeight="400px"
                showPills={false}
              />
            </div>
          </div>
        </div>
        <div className="sm:hidden animate-slide-in-left">
          <div className="sm:h-[500px] h-[300px] w-[360px] sm:w-[520px] xl:w-[750px] rounded-lg overflow-hidden shadow-xl">
            <div className="flex justify-center items-center h-full">
              <GallerySliderComp
                imgSlides={props.projectContribution.highlights}
                imgHeight="300px"
                showPills={false}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col h-[300px] sm:h-[500px] xl:h-full min-w-[360px] w-[360px] sm:w-[520px] px-[40px] sm:px-[80px] justify-center animate-slide-in-right">
          <h2 className="font-bold text-[14px] sm:text-[24px] text-primary-900 mb-4">
            {props.contTitle}
          </h2>
          <div className="prose prose-sm text-secondary-700">
            {props.projectContribution.description()}
          </div>
          <div
            className={`sm:pt-10 pt-4 sm:px-5 grid grid-cols-2 grid-rows-${Math.ceil(
              props.projectContribution.contribution.length / 2
            )} gap-4`}
          >
            {props.projectContribution.contribution.map((cont, index) => {
              return (
                <div
                  onClick={() => handleContributionClick(cont.title)}
                  key={index}
                  className="transform hover:scale-105 transition-all duration-200 bg-white/80 backdrop-blur-sm p-4 rounded-lg shadow-md cursor-pointer hover:shadow-lg group flex items-center justify-center min-h-[48px]"
                >
                  <h3 className="font-bold text-[12px] sm:text-[14px] text-primary-800 group-hover:text-primary-600 transition-colors text-center w-full">
                    {cont.title}
                  </h3>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="flex justify-center">
        <div className="xl:w-[1100px] sm:w-[700px] w-[360px] my-14 bg-gradient-to-r from-primary-200 via-primary-300 to-primary-200 h-[2px] rounded-full shadow-sm"></div>
      </div>
    </div>
  );
};

export default ProjectContributionView;
